// extracted by mini-css-extract-plugin
module.exports = {"text":"_1alJKh","prepaidCardWithDiscountModal":"_2DrZZd","shine-lines":"_2o18WK"};